module.exports = __webpack_public_path__ + "media/images/ncpctitlebanner-4ff868b6c42f44351e469c5328fe5377.gif";